import HelpIcon from "@mui/icons-material/Help";
import { IconButton, Tooltip } from "@mui/material";
import { config } from "config";

export function HelpLink() {
  const handleHelpClick = () => {
    window.open(config.helpUrl, "_blank");
  };

  return (
    <IconButton onClick={handleHelpClick}>
      <Tooltip title="Help">
        <HelpIcon />
      </Tooltip>
    </IconButton>
  );
}
